import { AxiosRequestConfig } from 'axios';
import { $host, $authHost, $authHostDownloadBlob } from './axiosSettings';

type TypeRequestAction =
	| 'getWithoutToken'
	| 'postWithoutToken'
	| 'putWithoutToken'
	| 'deleteWithoutToken'
	| 'getWithToken'
	| 'postWithToken'
	| 'putWithToken'
	| 'deleteWithTokenAndWithParameterInUrlLine'
	| 'getActualMediaPath'
	| 'downloadBlob';

export const request = ({
	typeOfRequest,
	url,
	data,
	config,
}: {
	typeOfRequest: TypeRequestAction;
	url: string;
	data?: object;
	config?: AxiosRequestConfig;
}) => {
	switch (typeOfRequest) {
		case 'getWithoutToken':
			return $host.get(url);
		case 'postWithoutToken':
			return $host.post(url, data);
		case 'putWithoutToken':
			return $host.put(url, data);
		case 'deleteWithoutToken':
			return $host.delete(url);
		case 'getWithToken':
			return $authHost.get(url, config);
		case 'postWithToken':
			return $authHost.post(url, data, config);
		case 'putWithToken':
			return $authHost.put(url, data);
		case 'deleteWithTokenAndWithParameterInUrlLine':
			return $authHost.delete(url);
		case 'downloadBlob':
			return $authHostDownloadBlob.get(url);
		default:
			throw new Error('Invalid request type...');
	}
};
